import * as React from 'react';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { tooltips } from 'src/constants/profileSettings';
import Profile from 'src/models/Profile';
import { Log, logAction, logType } from 'src/utils/api';
import { shortenTo } from 'src/utils/stringManipulation';
import StandardImage from "../../../../../assets/cards/standard.png";
import GeneratorEntity from '../../../../../models/Generator';
import translations from '../../translations';
import { history } from './../../../../../store/store';

interface IProps extends InjectedIntlProps {
  generator: GeneratorEntity

  delete: (generator: GeneratorEntity) => void
  run: (generator: GeneratorEntity) => void
  openTokenModalForGenerator: (gen: GeneratorEntity) => void;

  profile: Profile
}

interface ICatProps {
  category: string
}

const TableRow: React.SFC<IProps> = props => {
  const obj = {};

  const deleteMe = () => {
    props.delete(props.generator);
    Log(logType.action, logAction.clickHandler, "TableRow", "Pressed the Delete button!")
  }

  const importAllImages = () => {
    const context = require.context("../../../../../assets/cards", true);

    context
      .keys()
      .forEach((key: any) => {
        const countryCode = key
          .split("./")
          .pop() // remove the first 2 characters
          .substring(0, key.length - 6); // remove the file extension
        obj[countryCode] = context(key);
      });

    return obj;
  }

  //   tslint:disable-next-line:no-unused-expression
  const findImage: any = (categories: any) => {
    if (categories !== null && categories.length > 0) {
      // We've got categories!
      importAllImages();
      const imageList = Object.keys(obj);
      // We've got all images!
      const genName: string = props.generator.name
      const genExplanation: any = props.generator.explanation;

      for (const img of imageList) {
        if (genName.toLowerCase().search(img.toLowerCase()) !== -1) {
          return obj[img];
        }
      }

      for (const category of categories) {
        for (const img of imageList) {
          if (category.toLowerCase().indexOf(img.toLowerCase()) !== -1) {
            return obj[img];
          }
        }
      }
      if (genExplanation !== null && genExplanation !== undefined) {
        for (const img of imageList) {
          if (genExplanation.toLowerCase().search(img.toLowerCase()) !== -1) {
            return obj[img];
          }
        }
      }
      return StandardImage;
    }
    return StandardImage;
  };

  const run = () => {
    props.run(props.generator);
    Log(logType.action, logAction.clickHandler, "TableRow", "Pressed the Run button!")
  }

  const edit = (id: string) => {
    history.push('edit/' + id);
    Log(logType.action, logAction.clickHandler, "TableRow", "Pressed the Edit button!")
  }

  const openTokenModal = () => {
    props.openTokenModalForGenerator(props.generator);
  }

  return (
    <tr>
      <td style={{ cursor: "pointer" }} onClick={() => edit(props.generator.id || '')}><img src={findImage(props.generator.categories)} width="75px" height="75px" /></td>{/* tslint:disable-line */}
      <td style={{ cursor: "pointer" }} onClick={() => edit(props.generator.id || '')}>{shortenTo(props.generator.name, 32)}</td>{/* tslint:disable-line */}
      <td style={{ cursor: "pointer" }} onClick={() => edit(props.generator.id || '')}>{props.generator.explanation !== undefined ? shortenTo(props.generator.explanation, 64) : 'No description supplied'}</td>{/* tslint:disable-line */}
      <td style={{ cursor: "pointer" }} onClick={() => edit(props.generator.id || '')}>{/* tslint:disable-line */}
        <div className="field is-grouped is-grouped-multiline">
          {props.generator.categories !== null ? props.generator.categories.slice(0, 5).map((cat, index) => < Category category={cat} key={index} />) : null}
          {props.generator.categories !== undefined && props.generator.categories !== null && props.generator.categories.length >= 5 ? <Category category="..." key='' /> : null}
        </div>
      </td>
      <td>
        <div className="buttons">
          <a
            className={props.profile.showTooltips === tooltips.on ? "button is-small tooltip" : 'button is-small'}
            data-tooltip={props.intl.formatMessage(translations.run)}
            onClick={run}>
            <span className="icon"><i className="fa fa-play" /></span>
          </a>
          <Link to={"/edit/" + props.generator.id} className="button is-small"><FormattedMessage {...translations.lwedit} /></Link>
          <a onClick={deleteMe} className="button is-small"><FormattedMessage {...translations.delete} /></a>
          <a
            className={props.profile.showTooltips === tooltips.on ? "button is-small tooltip" : 'button is-small'}
            data-tooltip="Manage Public Tokens"
            onClick={openTokenModal}>
            <span className="icon"><i className="fa fa-share-square" /></span>
          </a>
        </div>
      </td>
    </tr>
  )
};

const Category: React.SFC<ICatProps> = props => {
  return (
    <div className="control">
      <div className="tags">
        <span className="tag is-dark">{shortenTo(props.category, 16)}</span>
        {/* <a className="tag is-delete"/> */}
      </div>
    </div>
  )
}

export default injectIntl(TableRow)



// WEBPACK FOOTER //
// ./src/Containers/generators/GeneratorList/GeneratorView/ListView/TableRow.tsx